export default [
  'https://www.nerdwallet.com/cdn/company/2021/values/Desktop@2x_0000_Informed-risk-taking.jpg',
  'https://www.nerdwallet.com/cdn/company/2021/values/Desktop@2x_0001_Ownership.jpg',
  'https://www.nerdwallet.com/cdn/company/2021/values/Desktop@2x_0002_Relentless-self-improvement.jpg',
  'https://www.nerdwallet.com/cdn/company/2021/values/Desktop@2x_0003_Open-candid-constructive.jpg',
  'https://www.nerdwallet.com/cdn/company/2021/values/Desktop@2x_0004_Consumer-company-team-self.jpg',
];
